/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-primary[_ngcontent-%COMP%]{background-color:#1b76bb;color:#fff}.btn[_ngcontent-%COMP%]{font-weight:500;font-size:16px;border-radius:25px;padding:8px 24px;border:none}"];
export { styles as styles };
